/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PositionV2Dto } from './positionV2Dto';
import { MapStatisticsDto } from './mapStatisticsDto';

export interface InterpolationMapSVGDto {
  lowerRight?: PositionV2Dto;
  statistics?: MapStatisticsDto;
  svgData?: string;
  upperLeft?: PositionV2Dto;
}
